




































































































































































import { Component, Mixins } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import AuthModule from '@/store/modules/Auth';
import ProfileModule from '@/store/modules/Profile';
import Table from '@/components/Table/Index.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import ApiKeyModule from '@/store/modules/ApiKey';

@Component({
  components: {
    Table,
  },
})
export default class ProfileView extends Mixins(ErrorHandleMixin) {
  AuthInstance = getModule(AuthModule, this.$store);

  ProfileInstance = getModule(ProfileModule, this.$store);

  userId = this.AuthInstance.user._id;

  TableHead = [
    [
      {
        displayName: 'profile.date',
      },
      {
        displayName: 'profile.ip',
      },
    ],
  ];

  ApiKeyInstance = getModule(ApiKeyModule, this.$store);

  data = [];

  ipWhitelist = '';

  dataModel = {
    profile: {
      ...this.AuthInstance.user.profile,
    },
  }

  created() {
    this.fetchURL();
    if (this.AuthInstance.user.ipWhitelist) {
      this.ipWhitelist = this.AuthInstance.user.ipWhitelist.join();
    }
  }

  async onSubmitInfo() {
    const { dataModel: { profile }, userId, ipWhitelist } = this;
    const data: any = {
      userId,
      profile,
      ipWhitelist,
    };
    if (this.ipWhitelist) {
      data.ipWhitelist = this.ipWhitelist.split(',');
    }
    const res = await this.ProfileInstance.UpdateProfile(data);
    this.checkError(res);
    this.ProfileInstance.FetchProfile();
  }

  async fetchURL() {
    this.GeneralInstance.toggleLoading(true);
    const res = await this.ApiKeyInstance.FetchSeamlessURL();
    if (res.code) {
      this.checkError(res);
    }
    this.data = res;
    this.GeneralInstance.toggleLoading(false);
  }
}
